import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { createTheme, ThemeProvider } from "@mui/material/styles";

export const theme = createTheme({
  typography: {
    fontFamily: "Arial, sans-serif",
  },
});

export const MapContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "calc(100vh - 100px)",
  maxHeight: "100%",
  // border: "1px solid #183059",
  boxSizing: "border-box",
  position: "relative",
  display: "flex",
  alignContent: "center",
  justifyContent: "center",
  [theme.breakpoints.down("md")]: {
    height: "calc(100vh - 100px)",
    // padding: "8px",
  },
  [theme.breakpoints.down("sm")]: {
   
    // padding: "5px",
  },
}));

export const MapWrapper = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "100%",
  position: "relative",
  overflow: "hidden",
  borderRadius: "16px",
  backgroundColor: "#f5f5f5",
  [theme.breakpoints.down("sm")]: {
    height: "calc(100vh - 175px)",
   
  },
}));


export const VehicleLine = styled(Box)(({ theme, offset = 0, zoomoffset = 0 }) => ({
  position: "absolute",
  width: "2px",
  height: `calc(40px + ${offset}px + ${zoomoffset}px)`,
  top: "75px",
  left: "50%",
  transform: "translateX(-50%)",
  zIndex: 998,
  [theme.breakpoints.down("sm")]: {
    height: `calc(30px + ${offset}px + ${zoomoffset}px)`,
    top: "80px",
  },
}));

// In MapStyles.js, update these styled components:

export const StopLine = styled(Box)(({ theme, zoomoffset = 0, offset = 0, alternate, rotation = 0 }) => ({
  position: "absolute",
  width: "2px",
  height: `calc(80px + ${zoomoffset}px + ${offset}px)`,
  top: `calc(-70px - ${zoomoffset}px - ${offset}px)`,
  left: alternate ? "calc(100% + 10px)" : "calc(-100% - 10px)",
  // Remove rotation transform - let it rotate with the map
  backgroundColor: "#B0B0B0",
  zIndex: 998,
  [theme.breakpoints.down("sm")]: {
    height: `calc(60px + ${zoomoffset}px + ${offset}px)`,
    top: `calc(-50px - ${zoomoffset}px - ${offset}px)`,
    left: alternate ? "calc(100% + 8px)" : "calc(-100% - 8px)",
  },
}));

export const StopLabel = styled(Box)(({ theme, alternate, zoomoffset = 0, offset = 0, rotation = 0 }) => ({
  position: "absolute",
  top: `calc(75px - ${zoomoffset}px - ${offset}px)`,
  left: alternate ? "calc(100% + 10px)" : "calc(-100% - 70px)",
  transform: `rotate(${-rotation}deg)`, // Keep counter-rotation for labels
  transformOrigin: "center center", // Add transform origin for better rotation
  backgroundColor: "white",
  color: "black",
  padding: "6px 12px",
  borderRadius: "8px",
  fontSize: "8px",
  // fontWeight: 500,
  boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
  whiteSpace: "nowrap",
  textAlign: alternate ? "left" : "right",
  zIndex: alternate ? 1001 : 1000,
  [theme.breakpoints.down("sm")]: {
    fontSize: "12px",
    padding: "4px 8px",
    top: `calc(80px - ${zoomoffset}px - ${offset}px)`,
    left: alternate ? "calc(100% + 20px)" : "calc(-100% - 90px)",
  },
}));

export const VehicleLabel = styled(Box)(({ theme, zoomoffset = 0, offset = 0, rotation = 0, isHighlighted }) => ({
  position: "absolute",
  top: `calc(70px - ${zoomoffset}px - ${offset}px)`,
  left: "50%",
  transform: `translateX(-50%) rotate(${-rotation}deg)`, // Keep counter-rotation
  transformOrigin: "center center", // Add transform origin
  color: "rgb(0, 0, 0)",
  fontSize: "8px",
  fontWeight: 700,
  fontFamily: "Arial, sans-serif",
  lineHeight: "16px",
  padding: "3px 6px",
  textAlign: "center",
  whiteSpace: "nowrap",
  borderRadius: "8px",
  backgroundColor: "white",
  boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
  zIndex: 1002,
  [theme.breakpoints.down("sm")]: {
    fontSize: "10px",
    padding: "4px 8px",
    top: `calc(70px - ${zoomoffset}px - ${offset}px)`,
  },
}));

export const InfoBox = styled(Box)(({ theme, rotation = 0 }) => ({
  display: "flex",
  width: "100%",
  maxWidth: "90vw",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: "15px",
  background: "#E8EAEE",
  borderRadius: "16px",
  boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
  fontFamily: "Arial, sans-serif",
  textAlign: "center",
  position: "absolute",
  bottom: "1px",
  // left: "50%",
  // transform: `translateX(-50%) rotate(${-rotation}deg)`, // Keep counter-rotation
  // transformOrigin: "center center", // Add transform origin
  zIndex: 1003,
  [theme.breakpoints.down("sm")]: {
    padding: "10px",
    maxWidth: "250px",
    bottom: "15px",
  },
}));

export const VehicleIconContainer = styled(Box)(({ theme }) => ({
  width: "34px",
  height: "34px",
  position: "relative",
  backgroundSize: "contain",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  zIndex: 999,
  [theme.breakpoints.down("sm")]: {
    width: "32px",
    height: "32px",
  },
}));

export const InfoText = styled(Box)(({ theme }) => ({
  fontSize: "32px",
  fontWeight: 700,
  color: "#FF0000",
  [theme.breakpoints.down("sm")]: {
    fontSize: "20px",
  },
}));

export const SubInfoText = styled(Box)(({ theme }) => ({
  fontSize: "24px",
  fontWeight: 500,
  color: "#000000",
  [theme.breakpoints.down("sm")]: {
    fontSize: "12px",
  },
}));

// In MapStyles.js

export const AnimatedCircle = styled(Box)(({ theme }) => ({
  position: "absolute",
  borderRadius: "50%",
  border: "0px solid rgba(0, 122, 255, 10)",
  backgroundColor: "rgba(0, 122, 255, 0.4)",
  width: "40px",
  height: "40px",
  transform: "translate(-50%, -50%)",
  animation: "grow 2s ease-in-out infinite",
  zIndex: 997,
  "&.outer": {
    width: "60px",
    height: "60px",
    animationDelay: "0.5s", // Stagger the outer circle animation
  },
  "@keyframes grow": {
    "0%": {
      transform: "translate(-50%, -50%) scale(1)",
      opacity: 0.8,
    },
    "50%": {
      transform: "translate(-50%, -50%) scale(1.5)",
      opacity: 0.4,
    },
    "100%": {
      transform: "translate(-50%, -50%) scale(1)",
      opacity: 0.8,
    },
  },
  [theme.breakpoints.down("sm")]: {
    width: "30px",
    height: "30px",
    "&.outer": {
      width: "50px",
      height: "50px",
    },
  },
}));